export default "__VITE_ASSET__CkkGRSUN__"